import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

import type { PropsWithClassName } from '@fv/client-types'

import type { DaisyProps } from './DaisyProps'

type Props = PropsWithClassName<PropsWithChildren & DaisyProps>
export const AdminBadge = ({ children, className, size, color }: Props) => {
  return (
    <div
      className={clsx(
        'badge',
        size && `badge-${size}`,
        color && `badge-${color}`,
        className,
      )}
    >
      {children}
    </div>
  )
}
